import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { PaMessageComponent } from 'src/app/shared/ui-kit/pa-message/pa-message.component';
import { SupportLinkV2Component } from '../../components/support-link/support-link.component';
import { AuthActionsService } from '../../services/auth-actions.service';
import { AuthSessionStore } from '../../services/auth-session.store';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pvz-link-step',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    NgClass,
    DatePipe,
    PaMessageComponent,
    SupportLinkV2Component,
  ],
  templateUrl: './pvz-link-step.component.html',
  styleUrls: ['../../styles/_step.styles.scss'],
})
export class PvzLinkStepComponent {
  readonly store = inject(AuthSessionStore);
  private readonly actions = inject(AuthActionsService);
  readonly environment = environment;

  selectPvzAccount(id: number): void {
    this.actions.selectPvzAccount(id);
  }
}
